// extracted by mini-css-extract-plugin
export var errorsContainer = "_ud-1";
export var link = "_ud-0";